import {
  FILTER_TYPE_AIRPORTS,
  FILTER_TYPE_DEPARTURE_DATE_FROM,
  FILTER_TYPE_DEPARTURE_DATE_TO,
  FILTER_TYPE_DURATIONS,
  FILTER_TYPE_PACKAGE_TYPES,
  FILTER_TYPE_PRICE_RANGE,
} from '@/constants';
import _ from 'lodash';
import axios from './axios.factory';

export default {
  translateActiveFilters(activeFilters) {
    const activeFilterTypes = Object.keys(activeFilters);
    const activeApiFilters = _.cloneDeep(activeFilters);

    if (activeFilterTypes.includes(FILTER_TYPE_AIRPORTS)) {
      activeApiFilters.airport = activeFilters[FILTER_TYPE_AIRPORTS];
      delete activeApiFilters[FILTER_TYPE_AIRPORTS];
    }

    if (
      activeFilterTypes.includes(FILTER_TYPE_DEPARTURE_DATE_FROM)
      || activeFilterTypes.includes(FILTER_TYPE_DEPARTURE_DATE_TO)
    ) {
      const departureDateFrom = activeFilters[FILTER_TYPE_DEPARTURE_DATE_FROM];
      const departureDateTo = activeFilters[FILTER_TYPE_DEPARTURE_DATE_TO];

      activeApiFilters.departureDate = {
        from: departureDateFrom,
        to: departureDateTo,
      };

      delete activeApiFilters[FILTER_TYPE_DEPARTURE_DATE_FROM];
      delete activeApiFilters[FILTER_TYPE_DEPARTURE_DATE_TO];
    }

    if (activeFilterTypes.includes(FILTER_TYPE_DURATIONS)) {
      activeApiFilters[FILTER_TYPE_DURATIONS] = [
        activeFilters[FILTER_TYPE_DURATIONS],
      ];
    }

    if (activeFilterTypes.includes(FILTER_TYPE_PACKAGE_TYPES)) {
      activeApiFilters[FILTER_TYPE_PACKAGE_TYPES] = [
        activeFilters[FILTER_TYPE_PACKAGE_TYPES],
      ];
    }

    if (activeFilterTypes.includes(FILTER_TYPE_PRICE_RANGE)) {
      const [minPrice, maxPrice] = activeFilters[FILTER_TYPE_PRICE_RANGE];

      activeApiFilters.minPrice = minPrice;
      activeApiFilters.maxPrice = maxPrice;

      delete activeApiFilters[FILTER_TYPE_PRICE_RANGE];
    }

    return activeApiFilters;
  },

  getAppData(host, pathname) {
    return axios.post('/search/api/initialise', {
      hostname: host,
      path: pathname,
    });
  },

  getFilterAvailablility(siteId, activeFilters) {
    const activeApiFilters = this.translateActiveFilters(activeFilters);
    return axios.post(`/search/api/filters/${siteId}`, activeApiFilters);
  },

  getPackages(siteId, activeFilters, amountPerPage, amountOffset, sortOrder) {
    const activeApiFilters = this.translateActiveFilters(activeFilters);
    return axios.post(`/search/api/results/${siteId}`, {
      activeFilters: activeApiFilters,
      page: {
        limit: amountPerPage,
        offset: amountOffset,
      },
      sortOrder,
    });
  },
};
